/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Box, Typography, Divider } from '@mui/material';
import './LetterRequestARModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalHeader from '../../CustomModal/ModalHeader';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import CompDirection from '../../../themes/CompDirection';
import { themes } from '../../../themes/themes';
import TakeActionSplitBtn from '../../../components/TakeActionSplitBtn/TakeActionSplitBtn';
import moment from 'moment';
import { DateField } from '../../../../components';
import { baseDateFormatting } from '../../../helper';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  trans?: any;
  fullData?: any;
  allActions?: any;
  userId?: any;
  handleSubmitAR_Request?: any;
}

const LetterRequestARModalPresenter = ({
  isModalOpen,
  closeModal,
  allActions,
  fullData,
  handleSubmitAR_Request,
  userId,
  trans,
}: ModalProps) => {
  const handleTakeAction = (x: any) => {
    if (x) {
      const payload = {
        event: 'letter request',
        instanceId: fullData?.instance_id,
        userId: userId,
        action: x ? x : '',
        context: {},
        model: 'letter_requests',
      };
      handleSubmitAR_Request(payload);
    } else {
      return;
    }
  };

  return (
    <CustomModal isModalOpen={isModalOpen} modalHeight="98vh" modalWidth="30vw">
      <ModalHeader
        modal={{ modal_title: trans('Payroll Settlement Action Required') }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '5px',
          }}
        >
          <Grid item xs={12}>
            <Box className="bg_border_ar_payroll_settlment">
              <Box
                style={{
                  borderRadius: '4px',
                  padding: '4px',
                  backgroundColor: '#F2E6F0',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: 'auto',
                  maxWidth: '5em',
                }}
              >
                <Typography
                  style={{
                    fontFamily: 'Lato',
                    fontSize: '0.7em',
                    color: themes.primaryMain,
                  }}
                >
                  {moment(fullData?.start_date).format('MMMM YYYY')}
                </Typography>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: 'auto',
                  borderRadius: '10px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '0.5em',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.7em',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Emp Name
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.7em',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Reference Id
                  </Typography>
                </Box>
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.7em',
                      fontWeight: 'bold',
                      color: themes.darkBlue,
                    }}
                  >
                    {`${fullData?.first_name} ${fullData?.last_name}`}
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.7em',
                      fontWeight: 'bold',
                      color: themes.darkBlue,
                    }}
                  >
                    {fullData?.reference_id}
                  </Typography>
                </Box>
                <Divider style={{ marginTop: '0.5em' }} />
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '0.5em',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.7em',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Department
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.7em',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Applied On
                  </Typography>
                </Box>
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.7em',
                      fontWeight: 'bold',
                      color: themes.darkBlue,
                    }}
                  >
                    {fullData?.department_name}
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.7em',
                      fontWeight: 'bold',
                      color: themes.darkBlue,
                    }}
                  >
                    <DateField
                      value={fullData?.updated_at}
                      format={baseDateFormatting}
                    />
                  </Typography>
                </Box>
                <Divider style={{ marginTop: '0.5em' }} />
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '0.5em',
                  }}
                >
                  <Box>
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '0.7em',
                        color: themes.greyModalTitle,
                      }}
                    >
                      Letter Type
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '0.7em',
                        fontWeight: 'bold',
                        color: themes.darkBlue,
                      }}
                    >
                      {fullData?.title}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '0.7em',
                        color: themes.darkBlue,
                      }}
                    >
                      Status
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '0.7em',
                        fontWeight: 'bold',
                        color: '#FF5263',
                      }}
                    >
                      Pending
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Box style={{ marginTop: '1em' }}>
                <CustomTextField
                  type="string"
                  label="Comment"
                  placeholder="Write Comment"
                />
              </Box>
              <Box style={{ marginTop: '1.5em', zIndex: '999', width: '100%' }}>
                <TakeActionSplitBtn
                  onAction={(x: any) => handleTakeAction(x)}
                  menu={allActions}
                  title={'Take Action'}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </CompDirection>
    </CustomModal>
  );
};

export default LetterRequestARModalPresenter;
